/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { createColumnHelper } from '@tanstack/react-table';
import { filterOutStandardQueryFields } from 'common/components/table/cell-formatters/fieldHelpers';
import { PayloadFieldsCellFormatter } from 'common/components/table/cell-formatters/payloadFieldCellFormatter';
import {
  formatIsoDateTimeStringToDisplayDate,
  secondsToHms
} from 'common/utils/LEGACY_timeHelpers';
import { NavLink } from 'react-router-dom';
import { ConversionSimpleViewResponse } from '../types/conversionSimpleViewResponse';
import FieldsRenderer from './shared/FieldsRenderer';
import { StickyOptions } from 'common/components/table/tableTypes';

const simpleColumnHelper = createColumnHelper<ConversionSimpleViewResponse>();

export const simpleColumnDefs = () => [
  simpleColumnHelper.accessor((row) => row.captureDateTime, {
    id: 'captureDateTime',
    header: () => <span>Date/Time</span>,
    enableColumnFilter: false,
    cell: (info) => (
      <span className="font-bold">
        {formatIsoDateTimeStringToDisplayDate(info.getValue())}
      </span>
    )
  }),
  simpleColumnHelper.accessor((row) => row.conversionPayloadFields, {
    id: 'payloadFields',
    header: () => 'Fields',
    enableColumnFilter: false,
    enableSorting: false,
    size: 300,
    cell: (info) =>
      FieldsRenderer({
        fieldsMap: info.getValue(),
        contextKey: 'payloadFields'
      })
  }),
  simpleColumnHelper.accessor(
    (row) => {
      return {
        header: row.firstClick.marketingSource,
        subheader:
          row.firstClick.marketingSource === 'Referral'
            ? row.firstClick.referrerUrl
            : undefined,
        enableColumnFilter: false,
        fields: row.firstClickLandingPageUrlAndQueryStringSegmentsFields
      };
    },
    {
      id: 'firstClick',
      header: () => <span>First Click</span>,
      enableColumnFilter: false,
      enableSorting: false,
      cell: (info) => (
        <PayloadFieldsCellFormatter
          additionalFieldsFilter={(fields) =>
            filterOutStandardQueryFields(fields)
          }
          fieldObject={info.getValue()}
          icon=""
        />
      ),
      size: 200
    }
  ),
  simpleColumnHelper.accessor(
    (row) => {
      return {
        header: row.lastClick.marketingSource,
        subheader:
          row.lastClick.marketingSource === 'Referral'
            ? row.lastClick.referrerUrl
            : undefined,
        enableColumnFilter: false,
        fields: row.conversionLandingPageUrlAndQueryStringSegmentsFields
      };
    },
    {
      id: 'lastClick',
      header: () => <span>Last Click</span>,
      enableColumnFilter: false,
      enableSorting: false,
      cell: (info) => (
        <PayloadFieldsCellFormatter
          additionalFieldsFilter={(fields) =>
            filterOutStandardQueryFields(fields)
          }
          fieldObject={info.getValue()}
          icon=""
        />
      ),
      size: 200
    }
  ),
  simpleColumnHelper.accessor((row) => row.webPageViewCount, {
    id: 'webPageViewCount',
    header: () => <span>Page Views</span>,
    enableColumnFilter: false,
    enableSorting: false,
    cell: (info) => info.getValue(),
    size: 125
  }),
  simpleColumnHelper.accessor((row) => row.sessions, {
    id: 'sessions',
    header: () => <span>Sessions</span>,
    enableColumnFilter: false,
    enableSorting: false,
    cell: (info) => info.getValue(),
    size: 125
  }),
  simpleColumnHelper.accessor(
    (row) => row.averageWebTouchpointDurationInSeconds,
    {
      id: 'averageWebTouchpointDurationInSeconds',
      header: () => <span>Duration</span>,
      enableColumnFilter: false,
      enableSorting: false,
      cell: (info) => secondsToHms(info.getValue()),
      size: 125
    }
  ),
  simpleColumnHelper.accessor((row) => row.visitorId, {
    id: 'Visitor',
    header: () => <span>Visitor</span>,
    enableColumnFilter: false,
    enableSorting: false,
    cell: (info) => {
      return (
        <NavLink
          title="View"
          to={`/visitors/${info.getValue()}`}
          className="bg-primary-700 hover:bg-primary-600 focus:bg-primary-800 active:bg-primary-800 border-primary-700 hover:border-primary-600 focus:border-primary-800 active:border-primary-800 px-5 py-2.5 transition-all text-white rounded border text-sm text-center"
        >
          View
        </NavLink>
      );
    },
    meta: {
      stickyOptions: {
        isEnabled: true,
        side: 'right'
      } as StickyOptions
    },
    enableResizing: false,
    size: 100
  })
];

export default simpleColumnDefs;
